export default {    
    setWorks(state,payload){
        state.works = payload;
    } 
}